'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ClassDetail = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _docs = require('../ui/docs');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ClassDetail = exports.ClassDetail = function ClassDetail(_ref) {
    var type = _ref.type,
        apiDocs = _ref.apiDocs;

    return React.createElement("div", null, React.createElement("h3", null, type.name), React.createElement(_docs.DocBlock, null, React.createElement(_docs.ImportAs, { declaration: type, apiDocs: apiDocs }), React.createElement(_docs.Markdown, { source: type.documentation })), React.createElement("h4", null, "Properties"), type.properties.map(function (prop) {
        return React.createElement(_docs.Property, { key: prop.name, prop: prop, apiDocs: apiDocs });
    }));
};
//# sourceMappingURL=class-detail.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/documittu-template-default/dist/components/docs/class-detail.js
 ** module id = 478
 ** module chunks = 0
 **/